import { useLayoutEffect, useState } from 'react';
import { useDocument } from './useDocument';
export const useHeroTitle = () => {
    const [hasHeroTitle, setHasHeroTitle] = useState(false);
    const myDocument = useDocument();
    useLayoutEffect(() => {
        if (myDocument) {
            const headingElements = myDocument.querySelector('h1.hero-widget__left-section-title');
            setHasHeroTitle(!!headingElements);
        }
    }, [myDocument]);
    return hasHeroTitle;
};
